/* import __COLOCATED_TEMPLATE__ from './service-step.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class RequestStepsServiceStep extends Component {}
